import styles from "./Results.module.css";
import { Col, Row } from "react-grid-system";
import Note from "./Note";
import { ResultDropdowns, ResultOption } from "../../lib/api/models";
import { CsrData, ResultDataByTab } from "./resultTypes";
import classNames from "classnames";
import StyledCheckbox from "../common/inputs/StyledCheckbox";
import StyledRadioButton from "../common/inputs/StyledRadioButton";

const strings = {
  activities: "Activities",
  web: "Web",
  transfer: "Transfer",
};

type Props = {
  data: CsrData;
  setData: React.Dispatch<React.SetStateAction<ResultDataByTab>>;
  options: ResultDropdowns;
  contactPerson: ResultOption | null;
  permissionToDiscuss: boolean | null;
};

export default function CustomerServiceContent({
  data: { activities, transfer },
  setData,
  options,
  contactPerson,
  permissionToDiscuss,
}: Props) {
  return (
    <>
      <Row className={styles.divider}>
        <Col>
          {options.activity && (
            <fieldset className={styles.unstyledFieldset}>
              <div
                className={classNames(styles.label, styles.headerLabel)}
                aria-hidden={true}
              >
                {strings.activities}
              </div>
              <legend className={styles.visuallyHidden}>
                {strings.activities}
              </legend>
              <div
                className={classNames(
                  styles.overflowRow,
                  styles.activityContainer,
                )}
              >
                {options.activity.map((item) => (
                  <div key={item.id} className={styles.activityInput}>
                    <StyledCheckbox
                      className={styles.csrInput}
                      value={item.value}
                      label={item.description}
                      checked={
                        activities.findIndex((i) => i.id === item.id) >= 0
                      }
                      onChange={() =>
                        setData((d) => ({
                          ...d,
                          ["CSR"]: {
                            ...d["CSR"],
                            activities:
                              activities.findIndex((i) => i.id === item.id) >= 0
                                ? d["CSR"].activities.filter(
                                    (i) => i.id !== item.id,
                                  )
                                : [...d["CSR"].activities, item],
                          },
                        }))
                      }
                    />
                  </div>
                ))}
                {options.webActivity && (
                  <div className={styles.webContainer}>
                    <div className={styles.webContent}>
                      <span className={styles.webTitle}>{strings.web}</span>
                      {options.webActivity.map((item) => (
                        <StyledCheckbox
                          key={item.id}
                          className={classNames(
                            styles.csrInput,
                            styles.webInput,
                          )}
                          value={item.value}
                          label={item.description}
                          checked={
                            activities.findIndex((i) => i.id === item.id) >= 0
                          }
                          onChange={() =>
                            setData((d) => ({
                              ...d,
                              ["CSR"]: {
                                ...d["CSR"],
                                activities:
                                  activities.findIndex(
                                    (i) => i.id === item.id,
                                  ) >= 0
                                    ? d["CSR"].activities.filter(
                                        (i) => i.id !== item.id,
                                      )
                                    : [...d["CSR"].activities, item],
                              },
                            }))
                          }
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </fieldset>
          )}
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          {options.transferTo && (
            <fieldset className={styles.unstyledFieldset}>
              <div
                className={classNames(styles.label, styles.headerLabel)}
                aria-hidden={true}
              >
                {strings.transfer}
              </div>
              <legend className={styles.visuallyHidden}>
                {strings.transfer}
              </legend>
              <div
                className={classNames(
                  styles.overflowRow,
                  styles.transferToContainer,
                )}
              >
                {options.transferTo.map((item) => (
                  <StyledRadioButton
                    key={item.id}
                    className={classNames(
                      styles.csrInput,
                      styles.transferToInput,
                    )}
                    inputClassName={styles.transferToInputValue}
                    value={item.value}
                    label={item.description}
                    checked={transfer?.id === item.id}
                    onChange={() =>
                      setData((d) => ({
                        ...d,
                        ["CSR"]: {
                          ...d["CSR"],
                          transfer: item,
                        },
                      }))
                    }
                  />
                ))}
              </div>
            </fieldset>
          )}
        </Col>
        <Col md={4}>
          <Note
            tab="CSR"
            data={{
              contactPerson,
              permissionToDiscuss,
              activities,
              transfer,
            }}
          />
        </Col>
      </Row>
    </>
  );
}
